module.exports = __webpack_public_path__ + "img/8-01.da38dc87.svg";